import styled from 'styled-components';
import * as React from 'react';

export const TextContainerStyle = styled.div`
  font-weight: lighter;

  p {
    padding: 0px 0em;
    width: 100%;
    max-width: 65em;
  }
  @media all and (min-width: 375px) and (max-width: 1100px) {
    p {
      padding: 0em 0em 0em 1em;
    }
  }
`;

export const TextContainer: React.FC<{ text?: string; style?: any }> = ({
  text,
  style,
}) => {
  return text ? (
    <TextContainerStyle
      dangerouslySetInnerHTML={{ __html: text }}
      style={style}
    />
  ) : null;
};
